import React from 'react';
import { useOutletContext } from 'react-router-dom';

// Nexus Core - 認証画面共通のヒーローテキスト (NTT e-Drone Technology キャッチコピー)
// Login / Register など、画面右側の画像エリアに表示するブランドメッセージ
export function AuthHeroOverlay() {
  return (
    <>
      <h2
        className="text-3xl lg:text-4xl font-bold text-white tracking-tight leading-tight text-center"
        style={{ textShadow: '0 5px 0 rgba(0, 0, 0, 0.3)' }}
      >
        ドローンで守る、大地と暮らし
      </h2>
      <p
        className="mt-5 text-sm lg:text-base font-bold text-white leading-relaxed text-center"
        style={{ textShadow: '0 2px 0 rgba(0, 0, 0, 0.3)' }}
      >
        食料生産の現場から、測量・インフラ点検まで空から社会を支える NTT e-Drone
      </p>
    </>
  );
}

// Nexus Core - 認証画面のカード本体
// 背景レイヤー (画像/白/ドット/線/heroOverlay) は AuthShell が保持
// collapsing / maxWidth は AuthShell の OutletContext から取得
export default function AuthLayout({ cardVisible, children }) {
  const ctx = useOutletContext() || {};
  const { collapsing = false, maxWidth = '440px' } = ctx;
  const effectiveMaxWidth = collapsing ? '64px' : maxWidth;

  return (
    <main
      className="relative z-10 w-full px-6 py-10 md:px-0 md:py-3 md:ml-3 transition-[max-width] duration-[600ms] ease-in-out"
      style={{ maxWidth: effectiveMaxWidth }}
    >
      <div
        className={`nexus-card-fade ${cardVisible ? 'is-visible nexus-card-stagger' : ''} bg-surface-container-lowest border border-border-light rounded-xl shadow-xl md:h-[calc(100vh-24px)] transition-[padding] duration-[600ms] ease-in-out ${
          collapsing ? 'p-3 md:p-3 md:overflow-hidden' : 'p-8 md:p-10 md:overflow-y-auto'
        }`}
      >
        {children}
      </div>
    </main>
  );
}
